import { Component, OnInit } from '@angular/core';
import { Organisation } from '../../models/types';
import { OrganisationServiceService } from '../services/organisation-service.service';
import { ActivatedRoute } from '@angular/router';
import { CommonModule } from '@angular/common';
import { switchMap } from 'rxjs/operators';
import { SportsProfilePageComponent } from '../components/sports-profile-page/sports-profile-page.component';
import { FiredepartmentPageComponent } from '../components/firedepartment-page/firedepartment-page.component';
import { LoginService } from '../services/login.service';
import { RegionalAuthorityComponent } from '../components/regional-authority/regional-authority.component';
import { OrganisationSlugMap } from '../../models/enums'; // 
import { ChurchPageComponent } from '../components/church-page/church-page.component';

@Component({
  selector: 'app-organisation-profile-page',
  standalone: true,
  imports: [
    CommonModule, 
    SportsProfilePageComponent, 
    FiredepartmentPageComponent, 
    RegionalAuthorityComponent,
    ChurchPageComponent],
  templateUrl: './organisation-profile-page.component.html',
  styleUrls: ['./organisation-profile-page.component.scss']
})
export class OrganisationProfilePageComponent implements OnInit {

  organisation: Organisation | null = null;
  isAdmin: boolean = false;

  constructor(
    private route: ActivatedRoute, 
    private organisationService: OrganisationServiceService,
    private loginService: LoginService
  ) {}

  ngOnInit() {
    this.isAdmin = this.loginService.IsAdminLoggedIn(); 

    this.route.params.pipe(
      switchMap(params => {
        const slug = params['slug']; 
        const orgName = OrganisationSlugMap[slug];

        if (!orgName) {
          throw new Error(`Slug '${slug}' not found in OrganisationSlugMap`);
        }


        return this.organisationService.getOrganisationIdByName(orgName).pipe(
          switchMap(response => {
            const orgID = response.body?.organisationID;
            if (!orgID) {
              throw new Error(`Organisation ID not found for name '${orgName}'`);
            }
            return this.organisationService.getOrganisation(orgID);
          })
        );
      })
    ).subscribe({
      next: (response) => {
        this.organisation = response.body;
      },
      error: (error) => {
        console.error('Error loading organisation profile:', error);
      }
    });
  }

}
